export default __webpack_public_path__ + "static/media/you-areWonderful.df937d60.webp";